import React, { memo } from "react";
import { GifPath } from "../../../assets/gifPath";


const FrontmGifLogoLoader = ({restartKey}) => {
    return (
        <div className="bg-white loader-ons w-full h-[100dvh] flex items-center justify-center absolute top-0 left-0 z-[99] ">
            <img
                key={restartKey}
                className="w-[155px]"
                src={`${GifPath.mainlogo}?v=${restartKey}`}
                alt="Onship || Images(svg, jpg, png)"
            />
        </div>
    )
};

export default memo(FrontmGifLogoLoader)

